import { useContext, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
// import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import LoadingButton from "@mui/lab/LoadingButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import InputAdornment from "@mui/material/InputAdornment";

import AuthContext from "../Context/Auth/AuthContext";
import { fetchUserData, userService } from "../Context/Auth/AuthService";
import { useAuth } from "../Context/Auth/AuthContext";
import { setCurrentUser, setUserData } from "../Context/Auth/Auth.actions";

// ----------------------------------------------------------------------

export default function LoginPage({ onLogin }) {
   const navigate = useNavigate();
   const { dispatch } = useAuth();
   const userNameRef = useRef();

   useEffect(() => {
      userNameRef.current.focus();
   }, []);

   const [showPassword, setShowPassword] = useState(false);
   const [loading, setLoading] = useState(false);
   let decodedUser = null;

   const handleClick = async (e) => {
      e.preventDefault();
      setLoading(true);

      const formData = new FormData(e.currentTarget);
      const data = Object.fromEntries(formData.entries());

      try {
         decodedUser = await userService(data, true);
         console.log(decodedUser.decodedUser.role === "user");
         if (decodedUser.decodedUser.role === "user") {
            const userData = await fetchUserData(decodedUser.decodedUser.id);
            console.log(userData);
            dispatch(setUserData(userData.data));
         }

         if (decodedUser.status === 200) {
            dispatch(setCurrentUser(decodedUser.data.token, decodedUser.decodedUser));
         }
         // dispatch(setCurrentUser(token, decodedUser));
      } catch (error) {
         console.log(error.message);
      } finally {
         onLogin(decodedUser);
         // console.log(userState);
         setLoading(false);
         navigate("/main");
      }
   };

   const renderForm = (
      <Box component="form" autoComplete="off" onSubmit={handleClick}>
         <Stack spacing={3}>
            <TextField name="email" label="Email" type="email" required inputRef={userNameRef} />

            <TextField
               name="password"
               label="Password"
               type={showPassword ? "text" : "password"}
               required
               InputProps={{
                  endAdornment: (
                     <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)}>
                           {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                     </InputAdornment>
                  ),
               }}
            />
         </Stack>

         <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
            {/* <FormControlLabel control={<Switch value={isUser} onChange={(e) => setUser(e.target.value)} />} label="Admin"  /> */}
            <Link variant="subtitle2" underline="hover">
               Forgot password?
            </Link>
         </Stack>

         <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            color="primary"
            loading={loading}
         >
            Login
         </LoadingButton>
      </Box>
   );

   return <>{renderForm}</>;
}
